module.exports = __webpack_public_path__ + "static/media/up-right-from-square-solid.f3cd79fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/up-right-from-square-solid.svg
// module id = 529
// module chunks = 0